
import _ from "lodash"

export default {
    columns: ( state ) => {
        return state.columns;
    },

    bodyRows: ( state ) => {
        return state.bodyRows;
    },

    footerRows: ( state ) => {
        return state.footerRows;
    },

    headerRows: ( state ) => {
        return state.headerRows;
    },

    orderedColumns: ( state ) => {
        let columns = state.columns.slice(0);

        columns.sort(function(a, b) {
            let aIndex = state.fixedColumns.indexOf(a.id);
            let bIndex = state.fixedColumns.indexOf(b.id);
            if( aIndex === bIndex ) return 0;
            if( aIndex === -1 ) return 1;
            if( bIndex === -1 ) return -1;
            return aIndex - bIndex;
        });

        return columns;
    },

    fixedColumns: ( state ) => {
        return state.fixedColumns;
    },

    sortedColumns: ( state ) => {
        return state.sortedColumns;
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/table_v3/getters.js